import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Download from './pages/Download';
import Footer from './components/Footer';
import BackToTop from "./pages/BackToTop";
import ScrollToTop from "./pages/ScrollToTop";
import Survey from "./pages/Survey";
import ThankYou from "./pages/ThankYou";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Map from './pages/map';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import CookiesPolicy from "./pages/CookiesPolicy";
import Disclaimer from "./pages/Disclaimer";
function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/download" element={<Download />} />
          <Route path="/survey" element={<Survey />} />
          <Route path="/map" element={<Map />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
<Route path="/thank-you" element={<ThankYou />} />
        </Routes>

        <Footer />

        {/* 🔼 Back to Top Button */}
        <BackToTop />
        <ScrollToTop/>
      </div>
    </Router>
  );
}

export default App;
